import styled from 'styled-components';

export const Base = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: 100%;
	margin-bottom: 16px;
`;

export const ChipRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 6px;
	padding: 4px 12px;
	min-height: 32px;
	border: 1px solid ${({ theme }) => theme.gray[400]};
	border-radius: 6px;
	background-color: ${({ theme }) => theme.gray[100]};

	&:focus-within {
		border-color: ${({ theme }) => theme.blue[500]};
		box-shadow: 0 0 0 2px ${({ theme }) => theme.blue[300]};
	}
`;

export const Input = styled.input`
	flex: 1;
	min-width: 120px;
	border: none;
	outline: none;
	background: transparent;
	font-size: 13px;
	color: ${({ theme }) => theme.gray[1000]};
	padding: 2px 0;

	&::placeholder {
		color: ${({ theme }) => theme.gray[600]};
	}
`;

export const Suggestions = styled.div`
	position: absolute;
	top: calc(100% + 4px);
	left: 0;
	right: 0;
	max-height: 200px;
	overflow-y: auto;
	background-color: ${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme }) => theme.gray[400]};
	border-radius: 6px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
	z-index: 10;
`;

export const SuggestionItem = styled.button<{ $active?: boolean }>`
	display: flex;
	width: 100%;
	padding: 8px 12px;
	border: none;
	background-color: ${({ theme, $active }) => ($active ? theme.gray[200] : 'transparent')};
	color: ${({ theme }) => theme.gray[1000]};
	font-size: 13px;
	text-align: left;

	&:hover {
		background-color: ${({ theme }) => theme.gray[200]};
	}
`;

